// extracted by mini-css-extract-plugin
export default {"muteNotifications":"MuteNotifications-module__muteNotifications___CFSjW","bell":"MuteNotifications-module__bell___MnLsp"};